import './ErrorAlert.css';

interface ErrorAlertProps {
  message: string;
}

export const ErrorAlert = ({ message }: ErrorAlertProps) => {
  return (
    <div className="error-alert" role="alert">
      {message}
    </div>
  );
};
